

import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminVendorsService} from "../../../../../services/api/admin/admin-vendors-api/admin-vendors-api.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminVendorsComponentDialog} from "./admin-vendors-create-edit-dialog/admin-vendors-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";

@Component({
  selector: 'app-admin-vendors',
  templateUrl: './admin-vendors.html'
})
export class AdminVendorsComponent implements OnInit {

  data;
  isLoading = true;

  constructor(private apiAdminVendorsService: ApiAdminVendorsService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
    this.getData();
  }

  ngOnInit(): void {
  }

  getData(){
    this.isLoading = true;
    this.apiAdminVendorsService.listAll().then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminVendorsComponentDialog, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminVendorsComponentDialog, id, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminVendorsService.delete(id).then(response => this.getData())
      }, cancelled => null)
  }



}
